import { useRouter } from 'next/router';
import { Text, Card } from '@wix/design-system';
import { FunctionComponent, useContext } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { clickOnAnswer } from '@wix/bi-logger-customer-care-data/v2';
import { DATA_HOOKS } from '../../../../../dataHooks';
import { useBI } from '../../../../../hooks/useBI';
import { Context } from '../../../../../context';
import { BI } from '../../../../../constants';
import css from './index.module.scss';

export type GenAnswerErrorProps = {
  searchQuestion: string;
  retryGenerateAnswer: () => Promise<void>;
  genAnswerRetries: number;
  setGenAnswerRetries: (genAnswerRetries: number) => void;
};

export const RETRIES_LIMIT = 3;

export const GenAnswerError: FunctionComponent<GenAnswerErrorProps> = ({ searchQuestion, retryGenerateAnswer, genAnswerRetries, setGenAnswerRetries }) => {
  const { sendBIEvent } = useBI();
  const { t } = useTranslation();
  const { searchSessionId } = useContext(Context);
  const { locale } = useRouter();

  const onClick = async () => {
    setGenAnswerRetries(genAnswerRetries + 1);
    await retryGenerateAnswer();
    await sendBIEvent(clickOnAnswer({
      summarized_answer_type: 'answer generation failed',
      clicked_item_type: 'summarized_answer_try_again',
      search_session_Id: searchSessionId,
      search_method: BI.SEARCH_METHOD.KNOWLEDGE_AGENT,
      source_name: BI.SOURCE_NAMES.SEARCH_RESULTS,
      kb_lang: locale
    }));
  };

  return (
    <Card className={css.errorCard} dataHook={DATA_HOOKS.GEN_ANSWER_ERROR_VIEW}>
      {t('search-results-page.gen-answer.error', {
        searchQuestion
      })}
      {genAnswerRetries < RETRIES_LIMIT &&
        <Text className={css.cta} onClick={onClick} dataHook={DATA_HOOKS.GEN_ANSWER_ERROR_VIEW_CTA}>
          {t('search-results-page.gen-answer.error-cta')}
        </Text>}
    </Card>
  );
};
